import { render, staticRenderFns } from "./WallCoverBlock.vue?vue&type=template&id=f78211d2"
import script from "./WallCoverBlock.vue?vue&type=script&lang=js"
export * from "./WallCoverBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports